module.exports = __webpack_public_path__ + "static/media/NMRiH4.2b608019.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/NMRiH4.jpg
// module id = 167
// module chunks = 0